module.exports = "<ul class=\"info-nav-tabs container mx-0\"><li class=info-nav-tabs__item ng-repeat=\"tab in $ctrl.infoTabs\" ui-sref-active=active><a class=info-nav-tabs__link ui-sref={{::tab.sref}}><span class=info-nav-tabs__icon ng-include=tab.icon></span> {{::tab.title}} <span ng-if=tab.count>{{tab.count}}</span></a></li></ul>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-tabs/components/gmc-info-nav-tabs/gmc-info-nav-tabs.component.html
// module id = 547
// module chunks = 31